export enum ExtendedKeyUsageId {
  SERVER_AUTHENTICATION = 1,
  CLIENT_AUTHENTICATION = 2,
}
